<nav class="navbar navbar-expand navbar-light sm-light py-0" style="background-color: rgba(0,0,0,.03);" >
    <ul class="navbar-nav mr-auto">
        <li routerLinkActive="active" class="nav-item" *ngIf="isAuthenticated"><a routerLink="/matches" class="nav-link">Matches</a></li>
        <li routerLinkActive="active" class="nav-item" *ngIf="isAuthenticated"><a routerLink="/play-match" class="nav-link">New-Match</a></li>
        <li routerLinkActive="active" class="nav-item" *ngIf="isAuthenticated"><a routerLink="/players" class="nav-link">Players</a></li>
    </ul>
    <ul class="navbar-nav">
        <li style="cursor: pointer;" class="nav-item" *ngIf="isAuthenticated" (click)="onLogout()"><a class="nav-link">Logout</a></li>
    </ul>
</nav>